import React from 'react';
import { renderMoney } from '../../../common/services/util';
import Button from '@material-ui/core/Button';
import { GRADO_COLORS, getModelSortKey } from './reacColumnsConfig';

export const columnsPublicReac = [
    {
        title: 'Ref.', field: 'reference', width: 80,
        cellStyle: { whiteSpace: 'nowrap' },
        render: r => r ? (
            <Button
                variant="outlined"
                size="small"
                style={{
                    fontWeight: 'bold',
                    color: 'black',
                    border: '2px solid black',
                    borderRadius: 6,
                    minWidth: 60,
                    padding: '2px 8px',
                    lineHeight: 1.4,
                    pointerEvents: 'none',
                }}
                disableRipple
                disableFocusRipple
            >
                {r.reference}
            </Button>
        ) : null,
    },
    {
        title: 'Modelo', field: 'modelo', defaultSort: 'desc',
        customSort: (a, b) => getModelSortKey(a.modelo) - getModelSortKey(b.modelo),
        width: 160,
    },
    { title: 'Capacidad', field: 'capacidad', width: 55 },
    {
        title: 'Precio', field: 'precio', type: 'numeric', width: 90,
        render: r => (r && r.precio != null) ? (
            <span style={{ fontWeight: 700 }}>{renderMoney(r.precio)}</span>
        ) : '',
    },
    { title: 'Procesador', field: 'procesador' },
    { title: 'RAM', field: 'ram', width: 45 },
    { title: 'Color', field: 'color', width: 110 },
    {
        title: 'Grado', field: 'grado',
        lookup: { A: 'A', B: 'B', C: 'C', D: 'D' },
        render: r => (r && r.grado)
            ? <span style={{ fontWeight: 700, color: GRADO_COLORS[r.grado] || '#333' }}>{r.grado}</span>
            : '',
    },
    {
        title: 'Condición', field: 'condicion',
        lookup: { usado: 'Usado', premium: 'Premium' },
        render: r => {
            if (!r || !r.condicion) return '';
            const isPremium = r.condicion === 'premium';
            return (
                <span style={{ fontWeight: 600, color: isPremium ? '#b8860b' : '#555' }}>
                    {isPremium ? 'Premium' : 'Usado'}
                </span>
            );
        },
    },
    {
        title: 'Salud (%)', field: 'salud', width: 50,
        render: r => {
            if (!r || r.salud == null || r.salud === '') return '';
            const v = Number(r.salud);
            const color = v >= 90 ? '#2e7d32' : v >= 80 ? '#f9a825' : '#c62828';
            return <span style={{ fontWeight: 700, color }}>{v}%</span>;
        },
    },
];
